module.exports = __webpack_public_path__ + "img/bg-top.4d0ec876.png";